<template>
    <v-container fluid>
        <v-skeleton-loader v-if="funeral_cost == null" type="card"></v-skeleton-loader>
        <v-row justify="center" align="center" v-else>
            <v-col cols="12">
                <div style="text-align:center;">
                    <v-btn color="#1976D2" dark class="pl-10 pr-10 mt-3" @click="print()">
                        <v-icon class="mr-2">mdi-content-save</v-icon>
                        Download
                    </v-btn>
                </div>
            </v-col>
            <v-card style="padding-left:10px;padding-right:10px;margin-top:3px;margin-bottom:3px;" elevation="0"
                width="1200" id="funeral_cost">
                <v-card-text class="mt-5">
                    <v-row no-gutters>
                        <v-col cols="3">
                            <v-img :src="funeral_cost.user.get_user_add_info.get_fd_info.company_logo_base64"
                                height="150" contain></v-img>
                        </v-col>
                        <v-col cols="6"></v-col>
                        <v-col cols="3">
                            {{ funeral_cost.user.get_user_add_info.get_fd_info.address }}
                            <br>
                            {{ funeral_cost.user.get_user_add_info.get_fd_info.town }}
                            <br>
                            {{ funeral_cost.user.get_user_add_info.get_fd_info.county }}
                            <br>
                            <!-- Eircode - {{ funeral_cost.user.get_user_add_info.get_fd_info.eircode }}
                            <br>
                            Tel: {{ funeral_cost.user.get_user_add_info.get_fd_info.mobile }} -->
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <h2>Present Day Funeral Cost Estimate</h2>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="3">
                            <b>Date of Estimate:</b>
                        </v-col>
                        <v-col cols="3">
                            <div contenteditable>
                                {{ $date().format('DD/MM/YYYY') }}
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <b>Address:</b>
                        </v-col>
                        <v-col cols="3">
                            <div contenteditable>
                                {{ funeral_cost.user.address }}
                                {{ funeral_cost.user.town }}
                                {{ funeral_cost.user.county }}
                                {{ funeral_cost.user.country }}
                                {{ funeral_cost.user.eircode }}
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <b>Name of the Deceased:</b>
                        </v-col>
                        <v-col cols="3">
                            <div contenteditable>
                                {{ funeral_cost.user.name }}
                            </div>
                        </v-col>
                        <v-col cols="3">
                            <b>Estimate To:</b>
                        </v-col>
                        <v-col cols="3">
                            <div contenteditable>
                                {{ funeral_cost.user.rep_details ? funeral_cost.user.rep_details.first_name + ' ' + funeral_cost.user.rep_details.last_name : '' }}
                            </div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="8">
                            <b>Funeral Director's Cost</b>
                        </v-col>
                        <v-col cols="4" style="text-align:right;">
                            <b>Amount</b>
                        </v-col>
                    </v-row>
                    <v-row v-for="(item, index) in funeral_cost.funeral_director_payments"
                        :key="'funeral_director_payments' + index" no-gutters>
                        <v-col cols="1">
                        </v-col>
                        <v-col cols="7">
                            {{ item.name }}
                        </v-col>
                        <v-col cols="4" style="text-align:right;">
                            €{{ item.amount }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="8">
                        </v-col>
                        <v-col cols="4" v-if="funeral_cost.funeral_director_payments.length > 0"
                            style="text-align:right;">
                            <hr>
                            Subtotal: €{{ subtotal1 }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="8">
                            <b>Third Party Cost</b>
                        </v-col>
                        <v-col cols="4" style="text-align:right;">
                            <!-- <b>Amount</b> -->
                        </v-col>
                    </v-row>
                    <v-row v-for="(item, index) in funeral_cost.payments_made" :key="'payments_made' + index"
                        no-gutters>
                        <v-col cols="1">
                        </v-col>
                        <v-col cols="7">
                            {{ item.name }}
                        </v-col>
                        <v-col cols="4" style="text-align:right;">
                            €{{ item.amount }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="8">
                        </v-col>
                        <v-col cols="4" v-if="funeral_cost.payments_made.length > 0" style="text-align:right;">
                            <hr>
                            Subtotal: €{{ subtotal2 }}
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="8">
                        </v-col>
                        <v-col cols="4" style="text-align:right;">
                            <hr>
                            <b>Total: €{{ total }}</b>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-col cols="12">
                            <p v-html="funeral_cost.notes"></p>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
import html2pdf from 'html2pdf.js'
export default {
    components: {
    },
    props: [
    ],
    data: () => ({
        api_url: null,
        funeral_cost: null,
    }),
    async mounted() {
        await this.getData()
    },
    created() {
        this.api_url = process.env.VUE_APP_API_URL
    },
    computed: {
        subtotal1() {
            let subtotal = 0
            if (this.funeral_cost != null) {
                this.funeral_cost.funeral_director_payments.forEach(payment => {
                    if (payment.amount > 0) {
                        subtotal += parseFloat(payment.amount)
                    }
                })
            }
            return subtotal
        },
        subtotal2() {
            let subtotal2 = 0
            if (this.funeral_cost != null) {
                this.funeral_cost.payments_made.forEach(payment => {
                    if (payment.amount > 0) {
                        subtotal2 += parseFloat(payment.amount)
                    }
                })
            }
            return subtotal2
        },
        total() {
            return this.subtotal1 + this.subtotal2
        },
    },
    methods: {
        async getData() {
            await this.$axios.get('/non_auth/decode_funeral_cost_id', { data: this.$router.currentRoute.params.token })
                .then(({ data }) => {
                    console.log(data)
                    if (data.response) {
                        this.funeral_cost = data.data
                        this.funeral_cost.funeral_director_payments = JSON.parse(data.data.funeral_director_payments)
                        this.funeral_cost.payments_made = JSON.parse(data.data.payments_made)
                    }
                })
        },
        print() {
            const opt = {
                margin: 0,
                filename: "Funeral Cost Estimate.pdf",
                image: { type: 'png', quality: 1 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' }
            }
            html2pdf().set(opt).from(document.getElementById("funeral_cost")).save()
        },
        isMobile() {
            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
    },
}
</script>

<style scoped lang="scss">
p,
b,
div {
    color: black;
}

p,
div {
    font-weight: 500;
}

b {
    font-weight: 800;
}

:deep(.col) {
    padding: 3px !important;
}
</style>